import { Directive, inject, input } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';
import { DIALOG_EVENT, DialogEvent, DialogEventType } from '../dialog.interface';

@Directive({
    selector: '[dialogOpen]',
    host: {
        '[class._dialog-open]': 'true',
        '(click)': 'open()'
    },
    standalone: true
})
export class DialogOpenDirective {
    dialogOpen = input.required<string>();

    protected dfEventService = inject(DfEventService);

    open() {
        this.dfEventService.dispatch({
            id: DIALOG_EVENT,
            data: new DialogEvent(DialogEventType.Open, this.dialogOpen())
        });
    }
}
